/**
 * juridico.ts — Impugnação e Defesa (F7).
 */

import type { components } from './generated/api'
import { api } from './http'

export type TipoPeca = 'impugnacao' | 'defesa'
export type PecaResumo = components['schemas']['PecaResumo']
export type DocumentoPeca = components['schemas']['DocumentoPeca']
export type AuditoriaDisponivel = components['schemas']['AuditoriaDisponivel']
export type ApontamentosAuditoria = components['schemas']['ApontamentosAuditoria']
export type GeracaoImpugnacaoInput = components['schemas']['GeracaoImpugnacaoInput']
export type GeracaoPeca = components['schemas']['GeracaoPeca']

export function listarPecas(tipo: TipoPeca) {
  return api<{ pecas: PecaResumo[] }>(`/api/v1/juridico/${tipo}`)
}

export function documentoPeca(tipo: TipoPeca, id: number) {
  return api<DocumentoPeca>(`/api/v1/juridico/${tipo}/${id}`)
}

export function excluirPeca(tipo: TipoPeca, id: number) {
  return api<{ removido: boolean }>(`/api/v1/juridico/${tipo}/${id}`, {
    method: 'DELETE',
  })
}

export function auditoriasDisponiveis() {
  return api<{ auditorias: AuditoriaDisponivel[] }>('/api/v1/juridico/auditorias')
}

export function apontamentosDaAuditoria(auditId: number) {
  return api<ApontamentosAuditoria>(
    `/api/v1/juridico/auditorias/${auditId}/apontamentos`,
  )
}

export function gerarImpugnacao(dados: GeracaoImpugnacaoInput) {
  return api<GeracaoPeca>('/api/v1/juridico/impugnacao/gerar', {
    method: 'POST',
    body: dados,
  })
}

/** A defesa manda dois arquivos: multipart, não JSON. */
export function gerarDefesa(edital: File, impugnacao: File) {
  const form = new FormData()
  form.append('edital', edital)
  form.append('impugnacao', impugnacao)
  return api<GeracaoPeca>('/api/v1/juridico/defesa/gerar', {
    method: 'POST',
    form,
  })
}
